import * as type from '../ActionTypes';

const initialState = {
  job: {},
  loading: false,
  error: null,
  invitations: [],
  sendingInvite: false,
  invitationSent: false,
  sendInviteError: null,
  sentInviteSuccessMsg: '',
  sendInviteCoderProfileStatus: false,
  inviteSendCoderStatus: false,
  inviteCodersdata: {},
  inviteCoderSError: null
};

export default function job(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_JOB_REQUEST_BY_ID:
      return {
        ...state,
        loading: true
      };
    case type.GET_JOB_SUCCESS_BY_ID:
      return {
        ...state,
        loading: false,
        job: action.payload,
        error: null
      };
    case type.GET_JOB_FAILURE_BY_ID:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case type.SEND_INVITE:
      return {
        ...state,
        sendingInvite: true,
        invitationSent: false,
        sentInviteSuccessMsg: '',
        sendInviteError: null,
        sendInviteCoderProfileStatus: false,
        inviteSendCoderStatus: false
      };
    case type.SEND_INVITE_SUCCESS:
      return {
        ...state,
        sendingInvite: false,
        invitations: action.payload,
        invitationSent: true,
        sendInviteError: null,
        sentInviteSuccessMsg: 'Invited coder successfully'
      };
    case type.SEND_INVITE_FAILURE:
      return {
        ...state,
        sendingInvite: false,
        sendInviteError: action.payload,
        invitationSent: false,
        sentInviteSuccessMsg: ''
      };
    case type.GET_ALL_INVITES:
      return {
        ...state,
        inviteCodersdata: {},
        inviteCoderSError: null
      };
    case type.GET_ALL_INVITES_SUCCESS:
      return {
        ...state,
        inviteCodersdata: action.data
      };
    case type.GET_ALL_INVITES_FAILURE:
      return {
        ...state,
        inviteCodersdata: {},
        inviteCoderSError: action.error
      };
    case type.CLEAR_INVITE_ERROR:
      return {
        ...state,
        sendInviteError: null
      };
    case type.CLEAR_JOB_DETAILS:
      return {
        ...state,
        job: {},
        loading: false,
        error: null
      };
    case type.CLEAR_JOB_INVITATIONS:
      return {
        ...state,
        invitations: [],
        sendingInvite: false,
        invitationSent: false,
        sendInviteError: null,
        sentInviteSuccessMsg: '',
        sendInviteCoderProfileStatus: false,
        inviteSendCoderStatus: false
      };
    case type.SEND_INVITE_CODER_PROFILE_STATUS:
      return {
        ...state,
        sendInviteCoderProfileStatus: true
      };
    case type.SEND_INVITE_CODER_STATUS:
      return {
        ...state,
        inviteSendCoderStatus: true
      };
    default:
      return state;
  }
}
